module.exports = __webpack_public_path__ + "img/recruittext.23e88d93.png";